/*
  Comportamentos da pagina de produto:
  1) botao "Comprar agora" que adiciona e segue direto para o checkout;
  2) barra de frete gratis que reage a troca de kit;
  3) descricao reorganizada em acordeao a partir dos titulos em negrito.

  Nada aqui altera o fluxo do "Adicionar ao carrinho" nativo, que continua
  somando itens no carrinho.
*/
(function () {
  'use strict';

  var moneyFormat = window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : 'R$ {{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return moneyFormat.indexOf('{{') > -1 ? moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, value) : 'R$ ' + value;
  }

  function selectedVariantPrice() {
    var checked = document.querySelector('.variant-pills-wrapper input[type="radio"]:checked + label.kit-card .kit-card__price');
    if (!checked) return null;
    var digits = checked.textContent.replace(/[^\d,]/g, '').replace(',', '.');
    var parsed = parseFloat(digits);
    return isNaN(parsed) ? null : Math.round(parsed * 100);
  }

  /* ---------- barra de frete gratis ---------- */

  function refreshFreeShipping() {
    var bar = document.querySelector('[data-free-ship]');
    if (!bar) return;
    var price = selectedVariantPrice();
    if (price === null) return;

    var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
    var text = bar.querySelector('[data-free-ship-text]');
    var missing = threshold - price;

    // as frases vem traduzidas do Liquid; o fallback cobre cache antigo do tema
    function frase(nome, padrao) {
      return bar.getAttribute('data-txt-' + nome) || padrao;
    }

    if (missing <= 0) {
      bar.classList.add('free-ship--reached');
      text.innerHTML =
        '<strong>' + frase('reached-strong', 'Frete grátis liberado') + '</strong> ' +
        frase('reached-rest', 'nesta opção.');
    } else {
      bar.classList.remove('free-ship--reached');
      text.innerHTML =
        frase('missing-pre', 'Faltam') + ' <strong>' + formatMoney(missing) + '</strong> ' +
        frase('missing-post', 'para o frete grátis.');
    }
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('.variant-pills-wrapper input[type="radio"]')) {
      // o tema reescreve o preco de forma assincrona; um tick basta
      setTimeout(refreshFreeShipping, 60);
    }
  });

  /* ---------- comprar agora ---------- */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-buy-now]');
    if (!button || button.disabled) return;

    event.preventDefault();

    // o gatilho pode estar fora do formulário, como o banner no fim da página
    var form = button.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (!form) {
      window.location.href = '/cart';
      return;
    }

    button.disabled = true;
    button.classList.add('is-loading');

    var body = new FormData(form);
    // o tema mantem o input de id desabilitado ate o submit
    if (!body.get('id')) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput) body.set('id', idInput.value);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body,
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add falhou');
        window.location.href = '/cart';
      })
      .catch(function () {
        button.disabled = false;
        button.classList.remove('is-loading');
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
  });

  /* ---------- descricao em acordeao ---------- */

  // secoes que ficam soltas na pagina, sem virar acordeao
  var ACC_ALWAYS_VISIBLE = ['benefic', 'benefíc'];

  function buildAccordion() {
    var source = document.querySelector('[data-pdp-description]');
    if (!source || source.dataset.pdpDone === 'true') return;

    var nodes = Array.prototype.slice.call(source.children);
    if (!nodes.length) return;

    var groups = [];
    var intro = [];

    nodes.forEach(function (node) {
      var isHeading =
        node.tagName === 'P' &&
        node.children.length === 1 &&
        node.children[0].tagName === 'STRONG' &&
        node.textContent.trim() === node.children[0].textContent.trim() &&
        node.textContent.trim().length < 60;

      // a promessa de frete ja aparece na barra propria, acima dos botoes
      if (/frete\s+gr[aá]tis/i.test(node.textContent)) return;

      if (isHeading) {
        groups.push({ title: node.textContent.trim(), nodes: [] });
      } else if (groups.length) {
        groups[groups.length - 1].nodes.push(node);
      } else {
        intro.push(node);
      }
    });

    if (groups.length < 2) return;

    var frag = document.createDocumentFragment();

    // o primeiro paragrafo solto vira a chamada acima do acordeao
    intro.forEach(function (node) {
      var text = node.textContent.trim();
      if (!text) return;
      var lead = document.createElement('p');
      lead.className = 'pdp-lead';
      lead.textContent = text;
      frag.appendChild(lead);
    });

    var wrap = document.createElement('div');
    wrap.className = 'pdp-acc';

    groups.forEach(function (group, index) {
      var normalized = group.title.toLowerCase();
      var alwaysVisible = ACC_ALWAYS_VISIBLE.some(function (term) {
        return normalized.indexOf(term) === 0;
      });

      var body = document.createElement('div');
      body.className = 'pdp-acc__body';
      group.nodes.forEach(function (node) {
        body.appendChild(node);
      });

      if (alwaysVisible) {
        var open = document.createElement('div');
        open.className = 'pdp-acc__item pdp-acc__item--open';

        var openHead = document.createElement('p');
        openHead.className = 'pdp-acc__head pdp-acc__head--static';
        openHead.textContent = group.title;

        open.appendChild(openHead);
        open.appendChild(body);
        wrap.appendChild(open);
        return;
      }

      var item = document.createElement('details');
      item.className = 'pdp-acc__item';
      if (index === 0) item.open = true;

      var head = document.createElement('summary');
      head.className = 'pdp-acc__head';
      head.innerHTML = '<span>' + group.title + '</span><span class="pdp-acc__sign" aria-hidden="true"></span>';

      item.appendChild(head);
      item.appendChild(body);
      wrap.appendChild(item);
    });

    frag.appendChild(wrap);
    source.innerHTML = '';
    source.appendChild(frag);
    source.dataset.pdpDone = 'true';
  }

  function init() {
    refreshFreeShipping();
    buildAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
